import { HttpResponse, type JsonBodyType } from "msw";

type Pagination = {
  count: number;
  total: number;
  perPage: number;
  currentPage: number;
  totalPages: number;
  links: { previous?: string; next?: string };
};

type SuccessResponseOptions = {
  status?: number;
  meta?: JsonBodyType;
  pagination?: Pagination;
};

type ErrorResponseOptions = {
  status: number;
  code: string;
  message: string;
  fields?: Record<string, string[]>;
};

export const successResponse = <Data extends JsonBodyType>(
  data: Data,
  { meta, pagination, status = 200 }: SuccessResponseOptions = {},
) => {
  return HttpResponse.json(
    {
      status,
      success: true,
      data,
      ...(meta === undefined ? {} : { meta }),
      ...(pagination === undefined ? {} : { pagination }),
    },
    { status },
  );
};

export const errorResponse = ({ code, fields, message, status }: ErrorResponseOptions) => {
  return HttpResponse.json(
    {
      status,
      success: false,
      error: { code, message, ...(fields === undefined ? {} : { fields }) },
    },
    { status },
  );
};

export const unauthenticatedResponse = () => {
  return errorResponse({ status: 401, code: "unauthenticated", message: "Unauthenticated." });
};
